import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'main-content-holder',
  templateUrl: './main-content-holder.component.html',
  styleUrls: ['./main-content-holder.component.scss']
})
export class MainContentHolderComponent implements OnInit {

  constructor() {
  }

  ngOnInit(): void {
  }

}
